import { Box } from "@chakra-ui/react";
import Router from "@root/routes";
import "./App.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import reduxStore from "@store/index";
import { ChakraWrapper } from "@components/index";
import { I18nextProvider } from "react-i18next";
import i18n from "@root/i18n";
import "./rc-pagination.css";
import { ProjectsProvider } from "./context/projects-context";

export const { store, persistor } = reduxStore();

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <Box className="App">
            <div id="scrollableDiv" className="hide-scrollbar">
              <ProjectsProvider>
                <ChakraWrapper>
                  <Router />
                </ChakraWrapper>
              </ProjectsProvider>
            </div>
          </Box>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
